module.exports = __webpack_public_path__ + "img/avatar.c06069a8.png";